module.exports = __webpack_public_path__ + "static/media/congrats.d50df185.webp";